/**
 * Normaliza un array de jornadas extrayendo campos numéricos.
 *
 * @param {Array} jornadas
 * @returns {Array<{ jornada: string|number, revenue: number, attendance: number, posicion: number|null, puntos: number, num_events: number, num_past_events: number }>}
 */
export function normalizeJornadas(jornadas) {
    if (!Array.isArray(jornadas)) return [];
    return jornadas.map(j => ({
        jornada: j.jornada ?? j.nombre_jornada ?? "",
        revenue: Number(j.revenue) || 0,
        attendance:
            j.attendance != null
                ? Number(j.attendance)
                : j.asistencia != null
                    ? Number(j.asistencia)
                    : 0,
        posicion:
            j.posicion != null && j.posicion !== "" ? Number(j.posicion) : null,
        puntos: Number(j.puntos) || 0,
        num_events: Number(j.num_events) || Number(j.num_eventos) || 0,
        num_past_events:
            Number(j.num_past_events) || Number(j.num_eventos_pasados) || 0,
    }));
}
